export default __webpack_public_path__ + "static/media/photo1.3659fab8.jpg";